<script setup lang="ts">
import BlueButton from "../../components/BlueButton.vue";
import { locale } from "../../locale";
import { roomState } from "../../states/room";
import GreetingPage from "../templates/GreetingPage.vue";

const back = () => {
  window.location.reload()
}
</script>
<template>
  <GreetingPage>
    <div class="block">
      <div class="text">{{ locale.endPage.leave }}</div>
      <div class="you-leave">
        <div class="icon">
          <svg
            width="48"
            height="49"
            viewBox="0 0 48 49"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              width="48"
              height="48"
              transform="translate(0 0.160156)"
              fill="white"
            />
            <path
              d="M31 13.6602V11.1602C31 9.5033 29.6569 8.16016 28 8.16016H16C14.3431 8.16016 13 9.5033 13 11.1602V38.1602C13 39.817 14.3431 41.1602 16 41.1602H28C29.6569 41.1602 31 39.817 31 38.1602V35.6602M23 24.1602H40M40 24.1602L36 20.1602M40 24.1602L36 28.1602"
              stroke="var(--main-red-color-regular)"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
        <div class="room-name">{{ roomState.name }}</div>
      </div>
      <div class="block-footer">
        <BlueButton width="106px" @click="back">{{locale.endPage.backBtn}}</BlueButton>
      </div>
    </div>
  </GreetingPage>
</template>
<style scoped>
.block-footer {
  display: flex;
  justify-content: center;
  position: absolute;
  bottom: 23.68px;
}
.block {
  width: 600px;
  height: 450px;
  display: flex;
  padding: 24px 12px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;
  border-radius: 8px;
  background: #fff;
  position: relative;
}

.you-leave {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  position: relative;
  top: 18px;
  position: absolute;
  top: 187px;
}

.room-name {
  font-family: Open Sans;
  font-size: 14px;
  font-weight: 600;
  line-height: 19.07px;
  text-align: center;
  text-overflow: ellipsis;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
}


.text {
  width: 100%;
  color: #292929;
  text-align: center;
  font-family: Open Sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  position: absolute;
  top: 24px;
}
</style>
